import styled from 'styled-components';

const FontSize13Div = styled.div`
  font-size: 13px;
  margin-bottom: 8px;
  font-weight: 400;
  color: #0658a9;
`;

export default FontSize13Div;
